// @flow

import type {Dispatcher} from 'docs/data';
import {COPY_STATUS} from '../CopyReducer';
import type {CopyEvent} from '../CopyReducer';

export const copyText = (dispatch: Dispatcher<CopyEvent>) => async (
  text: string,
) => {
  dispatch(COPY_STATUS.START);
  try {
    /* Copies a value to the clipboard */
    /* Yes, it's 2021 and this is the most stable way to copy to clipboard */
    const textarea = document.createElement('textarea');
    textarea.style.setProperty('position', 'absolute');
    textarea.style.setProperty('left', '-1000px');
    textarea.style.setProperty('top', '-1000px');

    textarea.value = text;
    let success = false;

    const body = document.body;
    if (body) {
      body.appendChild(textarea);
      textarea.select();
      success = document.execCommand('copy');
      body.removeChild(textarea);
    }

    dispatch(success ? COPY_STATUS.COMPLETE : COPY_STATUS.ERROR);
  } catch (e) {
    dispatch(COPY_STATUS.ERROR);
  }

  setTimeout(() => {
    dispatch(COPY_STATUS.START);
  }, 1500);
};
